<template>
    <div class="visitor-system">
      <div class="background-image">
        <img class="top-image" src="@/assets/di.png" alt="Top Image" />
        <span class="welcome-text">欢迎来到</span>
        <span class="department">{{qiyeName}}</span>
        <span class="dengji">小鹅学堡</span>
        <img class="top-top-image" src="@/assets/image.png" alt="Bottom Image" />
      </div>
      <div class="appointment-container">
        <h3>查看您班级当天的考勤情况</h3>
        <div class="appointment-method" @click="showLateStudentsModal">
          <img class="iconfont icon-wechat1" src="@/assets/chidao.png" alt="wechat-icon" />
          <span class="iconinfo">迟到学生</span>
          <span class="arrow">></span>
        </div>
        <div class="appointment-method" @click="showAbsentStudentsModal">
          <img class="iconfont icon-wechat2" src="@/assets/weidao.png" alt="wechat-icon" />
          <span class="iconinfo">未到学生</span>
          <span class="arrow">></span>
        </div>
      </div>
      <!-- 迟到学生弹窗组件 -->
      <div v-if="lateStudentsModal" class="modal">
        <div class="modal-content">
          <h3>迟到学生名单</h3>
          <ul class="student-names">
            <li v-for="student in uniqueLateStudents" :key="student.id" class="student-item">
              {{ student.studentName }}
            </li>
          </ul>
          <button @click="closeLateStudentsModal">关闭</button>
        </div>
      </div>
      <!-- 未到学生弹窗组件 -->
      <div v-if="absentStudentsModal" class="modal">
        <div class="modal-content">
          <h3>未到学生名单</h3>
          <ul class="student-names">
            <li v-for="student in absentStudents" :key="student.id" class="student-item">
              {{ student.name }}
            </li>
          </ul>
          <button @click="closeAbsentStudentsModal">关闭</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        qiyeName:'',
        lateStudents: [],
        absentStudents: [],
        lateStudentsModal: false,
        absentStudentsModal: false,
      };
    },
    computed: {
      uniqueLateStudents() {
        const names = {};
        return this.lateStudents.reduce((unique, student) => {
          if (!names[student.studentName]) {
            names[student.studentName] = true;
            unique.push(student);
          }
          return unique;
        }, []);
      },

    },
    methods: {

        



      showLateStudentsModal() {
        this.fetchLateStudents();
        this.lateStudentsModal = true;
      },
      closeLateStudentsModal() {
        this.lateStudentsModal = false;
      },
      async fetchLateStudents() {
        try {
            const token = localStorage.getItem('token')
          const headers = {
           Authorization: `${token}`,
         };
          const response = await axios.get('https://xbxy.xiao-e.tech/api/getChidaoRecord', { headers });
          if (response.data.code === 0) {
            this.lateStudents = response.data.data.lateStudents;
            console.log(this.lateStudents)
          } else {
            console.error('Failed to fetch data:', response.data.errmsg);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      },
      showAbsentStudentsModal() {
        this.fetchAbsentStudents();
        this.absentStudentsModal = true;
      },
      closeAbsentStudentsModal() {
        this.absentStudentsModal = false;
      },
      async fetchAbsentStudents() {
        try {
            const token = localStorage.getItem('token')
          const headers = {
           Authorization: `${token}`,
         };
          const response = await axios.get('https://xbxy.xiao-e.tech/api/getWeidaoRecord', { headers });
          if (response.data.code === 0) {
            console.log(response.data.data)
            this.absentStudents = response.data.data.weidaoStudents;
          } else {
            console.error('Failed to fetch data:', response.data.errmsg);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      },
      handleRedirect() {
        

        // 获取哈希部分
        const hash = window.location.hash;
        // 使用正则表达式提取查询参数
        const matchCode = hash.match(/code=([^&]+)/);
        const matchState = hash.match(/state=([^&]+)/);
        const token = hash.match(/token=([^&]+)/);
        const token1 = token ? token[1] : null;
        // console.log('tokennnnnnnnnnnnnnnnnnnnnnn',token1)
        if(token1){
          localStorage.setItem('token',token1)
          const token2 = localStorage.getItem('token');
              console.log('token', token2);
              this.fetchQiyeName(); // 在 token 获取成功后调用 fetchQiyeName
        }
        
        // 赋值
        this.code = matchCode ? matchCode[1] : null;
        this.state = matchState ? matchState[1] : null;
        // console.log('Code:', this.code);
        // console.log('State:', this.state);
          if (this.code && this.state) {
              // console.log('Code:', this.code);
              // console.log('State:', this.state);

              // 可以在这里发送这些参数到后端
              axios.post('https://xbxy.xiao-e.tech/api/redirect ', { code: this.code, state: this.state })
              .then(response => {
                  // console.log('Response:', response.data);
                  // console.log('response.data.data:', response.data.data);
                  //将response.data.data存入cookie中，后续调用其他api要将这个authorization放在头部发送给前端
                  const token = response.data.data;
                  if(token!=null){
                    // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
                  localStorage.setItem('token', token);
                  this.fetchQiyeName(); // 在 token 获取成功后调用 fetchQiyeName
                  }
                  if(token==null){
                    console.log('空的token',localStorage.getItem('token'))
                    this.fetchQiyeName(); // 在 token 获取成功后调用 fetchQiyeName
                  }

                  // const token1 = localStorage.getItem('token');
                  // console.log('token1', token1);
                  
              })
              .catch(error => {
                  console.error('Error:', error);
              });
          } else {
              console.error('Missing code or state parameter');
          }
      },
    // 获得企业名字
    async fetchQiyeName() {
        try {
            const token = localStorage.getItem('token')
          const headers = {
           Authorization: `${token}`,
         };
        console.log('schoolllllllllllllllllllllllllll',token)
        if (token) {
          const response = await axios.get('https://xbxy.xiao-e.tech/api/get_qiye_name', {headers});
          this.qiyeName = response.data.data; // 假设返回的数据中包含企业名字
          console.log(response)
          localStorage.setItem('qiyeName', this.qiyeName); // 存储到 localStorage
        } else {
          console.error('No token found in localStorage');
        }
      } catch (error) {
        console.error('Error fetching qiye name:', error);
      } 
    },
    },
    mounted() {
        this.handleRedirect();
        this.fetchQiyeName();
    }
  };
  </script>
  
  <style scoped>
  .visitor-system {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #5999fd;
  }
  
  .background-image {
    position: relative;
    width: 100%;
    height: 50vh;
    overflow: hidden;
  }
  
  .top-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .top-top-image {
    position: absolute;
    bottom: 120px;
    left: 50%;
    width: 182px;
    height: 189px;
  }
  
  .appointment-container {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-left: 5px;
    margin-top: -150px;
    margin-right: 5px;
    margin-bottom: 150px;
    flex: 1;
    z-index: 10; /* 确保这个值大于图案的 z-index */
    }

  .appointment-container h3 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
  }
  
  .appointment-method {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    background-color: #e0f0ff;
    border-radius: 5px;
    margin-bottom: 15px;
    height: 30px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
  
  .appointment-method:last-child {
    margin-bottom: 0;
  }
  
  .appointment-method span {
    font-size: 14px;
    color: #044da9;
  }
  
  .iconfont {
    margin-right: 10px;
  }
  
  .icon-wechat1 {
    width: 20px;
    height: 20px;
  }
  
  .icon-wechat2 {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }
  
  .arrow {
    color: #007bff;
  }
  
  .iconinfo {
    color: #007bff;
    font-weight: bold;
    flex-grow: 1;
  }
  
  .welcome-text {
    position: absolute;
    bottom: 250px;
    left: 20px;
    color: white;
    font-size: 24px;
    font-weight: bold;
    font-style: italic;
  }
  
  .dengji {
    position: absolute;
    bottom: 160px;
    left: 20px;
    font-size: 24px;
    color: white;
    text-align: left;
    font-weight: bold;
  }
  
  .modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0, 0.5);
    z-index: 20;
  }
  
  
  .close {
    float: right;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
  }
  
  .close:hover {
    color: red;
  }
  
  .qr-image {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }
  .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 600px; /* 固定宽度 */
  max-width: 600px; /* 固定最大宽度 */
  height: auto; /* 高度自适应 */
  overflow-y: auto; /* 允许垂直滚动 */
}

.student-names {
  list-style-type: none; /* 移除列表样式 */
  padding: 0; /* 移除内边距 */
  display: flex; /* 使用flex布局 */
  flex-wrap: wrap; /* 允许换行 */
  justify-content: space-between; /* 两端对齐 */
}

.student-item {
  background-color: #fff; /* 背景颜色 */
  border: 1px solid #ddd; /* 边框 */
  border-radius: 4px; /* 圆角 */
  padding: 5px; /* 内边距 */
  margin-bottom: 10px; /* 底部外边距 */
  box-sizing: border-box; /* 盒模型 */
  text-align: center; /* 文本居中 */
  color: #007bff; /* 文字颜色 */
  font-size: 1.0em; /* 字体大小 */
  flex: 0 0 32%; /* flex布局属性，不允许缩小，不允许放大，基础宽度为32% */
  max-width: 32%; /* 最大宽度为32% */
}
  .department {
  position: absolute;
  bottom: 200px; /* 距离底部100px */
  left: 20px; /* 距离左侧20px */
  font-size: 30px; /* 设置字体大小 */
  color: #f4cd4e; /* 设置字体颜色 */
  text-align: left; /* 设置文本对齐方式为左对齐 */
  font-weight: bold; /* 设置字体加粗 */
}
  </style>